type ChkBoxProps = {
  label: string;
  selected: boolean;
  size: string; //medium, small
  onClick: (item: any) => void;
  onLabelClick?: () => unknown;
  labelClassName?: string;
};

type ChkBoxIconType = {
  size: string;
  color: string;
};

const ChkBoxIcon = (props: ChkBoxIconType) => {
  const { size, color } = props;
  if (size == "small") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M2.25 9L6.75 13.5L15.75 4.5"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M3 12L9 18L21 6"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
};

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=200-1705&t=3lunUvpzgaQBTI5S-4
const ChkBox = (props: ChkBoxProps) => {
  const { label, selected, size, onClick, onLabelClick, labelClassName } =
    props;

  return (
    <div
      className={`chk-box ${size}`}
      onClick={() => {
        onClick(label);
      }}
    >
      {selected && (
        <div className={`chk-box-item selected ${size}`}>
          {/* <i className="icon-icon-check" /> */}
          <ChkBoxIcon size={size} color={"white"} />
        </div>
      )}
      {!selected && <div className={`chk-box-item ${size}`}></div>}

      {label && (
        <span className={`gray-700 ${labelClassName}`} onClick={onLabelClick}>
          {label}
        </span>
      )}
    </div>
  );
};

export { ChkBox };
